import type { TFunction } from "i18next"
import type { AgentTurn, PipelineStep } from "@/reducers/agentPipelineSlice"

/** The step the agent is on now: the last one still running. */
export const currentStep = (steps: PipelineStep[]): PipelineStep | undefined =>
  steps.filter((step) => step.status === "started").at(-1)

/**
 * What the live row says: the step running now, else what the agent said it
 * is doing, else "Myślę" ("Thinking"). The agent sends each step's label as
 * its activity too, so once a step has run the activity names a finished step.
 */
export const liveLabel = (
  t: TFunction,
  turn: AgentTurn | undefined,
): string => {
  if (!turn) return t("ai.turnStatus.thinking")
  const step = currentStep(turn.steps)
  if (step) return step.label
  const activity = turn.steps.length === 0 ? turn.activity : undefined
  return (
    activity?.trim().replace(/\s*(?:\.{3}|…)\s*$/, "") ||
    t("ai.turnStatus.thinking")
  )
}

/**
 * "0 s" … "59 s", "1 min 3 s", "2 min". The number sits before the unit so
 * Polish needs no plural forms.
 */
export const formatTurnDuration = (ms: number): string => {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000))
  if (totalSeconds < 60) return `${totalSeconds} s`
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return seconds === 0 ? `${minutes} min` : `${minutes} min ${seconds} s`
}
